<template>
  <div class="workbench-component-contract-container default-table">
    <el-form :inline="true" :model="formSearch" size="mini">
      <el-form-item label="客户名称" class="form-item-customer">
        <el-input v-model="formSearch.customer_name" placeholder="客户名称" clearable/>
      </el-form-item>
      <el-form-item label="系统编号">
        <el-input v-model="formSearch.covenant_no" placeholder="系统编号" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;margin-right: 0;">
        <el-button v-if="userAuth.can_store_covenants" type="primary" @click="toStoreContract">新建合同</el-button>
      </el-form-item>
    </el-form>
    <template>
      <el-table :data="tableData" border height="calc(100% - 88px)">
        <el-table-column prop="covenant_no" label="系统编号" align="center" min-width="80"/>
        <el-table-column prop="covenant_title" label="合同标题" align="center" min-width="120" show-overflow-tooltip/>
        <el-table-column prop="customer_name" label="客户名称" align="center" min-width="120" show-overflow-tooltip/>
        <el-table-column prop="annexes_count" label="合同附件" align="center" min-width="80">
          <template slot-scope="{row:{annexes_count}}">
            <span>{{ annexes_count }} 个文件</span>
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人" align="center" min-width="80" show-overflow-tooltip/>
        <el-table-column prop="created_at" label="创建时间" align="center" min-width="80" show-overflow-tooltip/>
        <el-table-column label="操作" align="center" min-width="80">
          <template slot-scope="{row}">
            <span v-if="userAuth.can_see_covenant_files" class="span-btn" @click="handelPreview(row)">查看附件</span>
            <span v-if="userAuth.can_store_covenants" class="span-btn" @click="handelEdit(row)"
                  style="margin: 0 8px;">编辑</span>
            <el-popover v-if="userAuth.can_delete_covenants" placement="left" trigger="click"
                        :ref="`popover-` + row.covenant_no">
              <div>
                <div>确认删除吗?删除将自动解约该合同下的订单。</div>
                <div style="margin-top: 20px;text-align: center;">
                  <el-button slot="reference" size="mini" @click="handelDelete(row,false)">取消</el-button>
                  <el-button type="primary" slot="reference" size="mini" @click="handelDelete(row,true)">确定
                  </el-button>
                </div>
              </div>
              <span slot="reference" class="span-btn">删除</span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          :current-page="formSearch.page"
          :page-size="formSearch.page_size"
          layout="total, prev, pager, next"
          :total="formSearch.total"
          @current-change="handleCurrentChange"
          style="margin-top: 10px;float: right;"
      />

    </template>
    <contract-store ref="ContractStore" @success="callbackSuccess"/>
  </div>
</template>

<script>


import ContractStore from "@/views/workbench/Contract/contractStore.vue";
import {orderCovenantDelete, orderCovenantQuery} from "@/api/orderCovenant";

export default {
  name: "contracts",
  components: {ContractStore},
  inject: ["refreshSummation"],
  data() {
    return {
      formSearch: {
        page: 1,
        page_size: 20,
        total: 0,
        customer_name: null,
        covenant_no: null,
      },
      tableData: [],
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handelEdit(row) {
      const form = row
      form.type = 'EDIT'
      this.$refs.ContractStore.bridgeToEdit(form)
    },
    async handelDelete(obj, isSure) {
      const dom = this.$refs[`popover-` + obj.covenant_no]
      if (!isSure) {
        dom && (dom.showPopper = false)
        return false;
      }
      const response = await orderCovenantDelete({id: obj.id})
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return false;
      }

      dom && (dom.showPopper = false)
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.getTableData();
    },
    /**
     * 去预览
     * @param obj
     */
    handelPreview(obj) {
      const {href} = this.$router.resolve({
        name: `FilesPreview`,
        query: {
          covenant_title: obj.covenant_title,
          covenant_id: obj.id,
        }
      });
      window.open(href, "_blank");
    },
    callbackSuccess() {
      this.refreshSummation();
      this.getTableData();
    },
    toStoreContract() {
      this.$refs.ContractStore.bridgeToAdd();
    },
    handleCurrentChange(val) {
      this.formSearch.page = val
      this.getTableData()
    },
    async getTableData() {
      const response = await orderCovenantQuery(this.formSearch)
      if (!response.success) {
        this.tableData = []
        return false;
      }

      this.formSearch.total = response.data.pages.total || 0;
      this.tableData = response.data.list || []
    }
  }
}
</script>

<style lang="scss">
.workbench-component-contract-container {
  height: 100%;

  //.span-btn + .span-btn {
  //  margin-left: 8px;
  //}
}
</style>
